<script setup lang="ts">
import { VueFinalModal } from 'vue-final-modal'
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import 'vue-lite-youtube-embed/style.css'

defineProps<{
  video: YouTubeVideo
}>()

const emit = defineEmits<{
  (e: 'confirm'): void
}>()
</script>

<template>
  <VueFinalModal
    class="flex justify-center items-center"
    overlay-class="bg-black/50"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    content-class="flex flex-col max-w-6xl mx-4 bg-white  space-y-2 relative max-h-[90vh] overflow-y-auto shadow-xl rounded-2xl"
  >
    <button
      class="sticky top-3 right-3 z-10 ml-auto bg-zinc-100 p-3 flex justify-center items-center cursor-pointer hover:bg-primary duration-200 hover:text-white rounded-full"
      @click="$emit('confirm')"
    >
      <Icon
        name="ri:close-line"
        class="text-2xl"
      />
    </button>
    <div class="p-4 lg:p-12">
      <h1 class="text-2xl md:text-3xl lg:text-4xl mb-3">
        {{ video.title }}
      </h1>
      <p class="mb-6 text-primary">
        Published {{ useDateFormat(video.publishedAt, 'YYYY/MM/DD') }}
      </p>
      <LiteYouTubeEmbed
        :id="video.videoId"
        :title="video.title"
      />
      <p class="pt-6">
        {{ video.description }}
      </p>
    </div>
  </VueFinalModal>
</template>
